export default function checkForArray(suggestions) {
  if (!Array.isArray(suggestions)) {
    throw new Error(
      '[Typeahead] The typeahead source MUST return an array, even if its async'
    );
  }
}
